import Cookies from 'js-cookie';
import { loadJs } from '../utils';

export default class CookieBar {
	static init() {
		document.addEventListener('bless', () => {
			const cookiebars = document.querySelectorAll('#cookie-notice');

			cookiebars.forEach(cookiebar => {
				new CookieBar(cookiebar);
			});
		});
	}

	constructor(cookiebar) {

		this.cookie = Cookies.get('cookiemessage');
		this.cookiebar = cookiebar;

		if(!this.cookiebar) {
			return;
		}

		this.acceptButton = this.cookiebar.querySelector('.c-cookie-notice__accept');
		this.declineButton = this.cookiebar.querySelector('.c-cookie-notice__decline');

		if(!this.cookie) {
			this.acceptButton.addEventListener('click', this.accept.bind(this));
			this.declineButton.addEventListener('click', this.decline.bind(this));
			this.show();
		} else {
			this.cookiebar.remove();
			if (this.cookie !== 'declined') {
				this.loadGa();
			}
		}
	}

	show() {
		this.cookiebar.classList.add('active');
		this.cookiebar.focus();
	}

	hide() {
		this.cookiebar.classList.remove('active');
	}

	accept() {
		Cookies.set('cookiemessage', 'accepted', { expires: 365 });
		this.hide();
		this.loadGa();
	}

	decline() {
		Cookies.set('cookiemessage', 'declined');
		this.hide();
	}

	loadGa() {
		const loadPromise = new Promise((resolve, reject) => {
			if (window.WPURLS.env !== 'production') {
				reject('Niet op productie dus GA wordt niet ingeladen.');
				return;
			}
			loadJs('https://www.googletagmanager.com/gtag/js?id=XXX-XXXXXXX').then(() => {
				window.dataLayer = window.dataLayer || [];
				window.gtag = function(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', 'XXX-XXXXXXX');
				this.gaLoaded = true;
				resolve();
			});
		});
		loadPromise.catch(message => {
			console.warn(message);
		});
	}
}
